'use strict';

angular.module('atex.dam').controller('DamSearchFormController', [ '$scope', '$q', '$timeout', 'configuration', 'DamFoldersService','DamQueuesService','DamAclPermissionService', 'DamDistributionListService','UIConfigurationService', 'DamSearchService', '$rootScope',
  function($scope, $q, $timeout, configuration, DamFoldersService, DamQueuesService, DamAclPermissionService, DamDistributionListService, UIConfigurationService, DamSearchService, $rootScope) {
    $scope.partitionConfigurations = [];
    $scope.partitionConfigurations["production"] = {
      "id": "production",
      "label": "__PRODUCTION_PARTITION__",
      "icon": "fa fa-globe",
      "icon-color": "black"
    };
    $scope.partitionConfigurations["incoming"] = {
      "id": "incoming",
      "label": "__INCOMING_PARTITION__",

      "icon": "fa fa-rss",
      "icon-color":"blue"
    };

    $scope.partitionConfigurations["archive"] = {
      "id": "archive",
      "label": "__ARCHIVE_PARTITION__",

      "icon": "fa fa-archive",
      "icon-color":"green"
    };

    $scope.searchTag = undefined;
    $scope.lastExtraInfo = undefined;

    $scope.info = function () {
      var physical = $scope.physicalPages || false;

      return (physical) ?
        {
          name: "physical-pages-search-form",
          id: "desk-physical-pages-search-form",
          profile: "search-forms"
        } : {
          name: "search-form",
          id: "desk-search-form",
          profile: "search-forms",
          selectedTab: $scope.selectedTab
        };
    };

    $scope.disabled = function() {
      var disabled = false;

      _.each(['pubdate_atex_desk_ss', 'publication_atex_desk_ss'], function (_field) {
        var value = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "set/" + _field);
        if(typeof value === "undefined") {
          disabled = true;
        } else if(Array.isArray(value))  {
          disabled = (value.length === 0) || disabled;
        } else if(typeof value === "object") {
          disabled = Object.keys(value).length === 0 || disabled;
        }
      });

      if ($rootScope.clearAllSearchInTab){
        $scope.selectedTab = "incoming";
        $scope.clearAdvancedFields(true,true);
        $scope.selectedTab = "archive";
        $scope.clearAdvancedFields(true,true);
        $scope.selectedTab = "production";
        $scope.clearAdvancedFields(true,true);
        $rootScope.clearAllSearchInTab = false;
      }

      return disabled;
    };

    $scope.foldersService = DamFoldersService;

    $scope.setDefaultSorting = function (reset) {

      if (reset) {
        $scope.queryModel = {};
      }

      // this is the promise that get the correct default sort value.
      var p;

      // if there is no selected tab it means that we have the simple search form without tabs.
      if ($scope.selectedTab) {
        // the 'getDefaultTabSortValue' will return the default sort value for the given tab
        // or the default sort value.
        p = configuration.getDefaultTabSortValue($scope.selectedTab);
      } else {
        // when we are in the simple search form we will use the default sort value.
        p = configuration.getDefaultSortValue();
      }
      return p.then(function(value) {
        $scope.queryModel.sortValue = value;
        $scope.queryModel.sortOrderValue = "desc";
      });
    };

    var tags = ['physicalPage_ss','tag_dimension.partition_ss', 'atex_desk_objectType'];
    var exclude=['fields', 'sortValue', 'sortOrderValue', 'viewMode'];

    var _default = {
      set: {
        "physicalPage_ss": "true",
        "tag_dimension.partition_ss": [{
          "id": "production",
          "label": "__PRODUCTION_PARTITION__",
          "icon": "fa fa-globe",
          "icon-color": "black"
        }],
        "atex_desk_objectType": [{
          "id": "page",
          "label": "__PAGE_LABEL__",
          "icon": "fa fa-file"
        }]
      },
      "isDynamic": "false",
      "viewMode": "physical-page",
      "sortValue": "pageSequence_atex_desk_i",
      "sortOrderValue": "asc"
    };

    $scope._defaultPhysQuery = _default;

    $scope.resetQuery = function (clearFolder, fromUI) {
      if (fromUI) {
        for (var field in $scope.query) {
          if ($scope.query.hasOwnProperty(field)) {
            if (!_.contains(exclude, field)) {
              delete $scope.query[field];
            }
          }
        }

        if ($scope.query.fields) {
          $scope.query.fields = _.filter($scope.query.fields, function (_field) {
            return tags.includes(_field.key);
          });
        }

        if (!$scope.query.set) {
          $scope.query.set = angular.copy(_default.set);
        }

        $scope.query.isDynamic = "false";
        $scope.query.viewMode = "physical-page";
        $scope.query.sortValue = "pageSequence_atex_desk_i";
        $scope.query.sortOrderValue = "asc";

        $scope.queryModel = angular.copy(_default);

        $rootScope.$broadcast('dam:clearSearchUIFields');
      }

      if (clearFolder) {
        DamFoldersService.resetSelection(true);
        DamQueuesService.resetSelection(true);
      }
    };

    $scope.clearAdvancedFields = function (clearFolder, fromUI) {
      $("#searchvalueinput").val('');
      $rootScope.lastSearchValueInput = "";
      var query = DamSearchService.getCurrentAdvQuery();
      delete query.fields;
      if (fromUI) {
        for (var field in $scope.query) {
          if ($scope.query.hasOwnProperty(field)) {
            delete $scope.query[field];
          }
        }

        $scope.setDefaultSorting(true);
      }

      if (clearFolder) {
        $scope.searchTag = undefined;
      }

      $scope.query.tab = $scope.selectedTab;
      if ($scope.query.set === undefined){
        $scope.query.set = {};
      }

      if($scope.partitionConfigurations && $scope.selectedTab && $scope.partitionConfigurations[$scope.selectedTab]) {
        $scope.query.set["tag_dimension.partition_ss"] = [$scope.partitionConfigurations[$scope.selectedTab]];
      }


        if ($scope.query && $scope.query.set && $scope.query.set["atex_desk_text"] === undefined) {
          $scope.query.set["atex_desk_text"] = $rootScope.lastSearchValueInput;
        }

      $scope.queryModel.tab = $scope.selectedTab;
      if ($scope.queryModel.set === undefined){
        $scope.queryModel.set = {};
      }
      if($scope.partitionConfigurations && $scope.selectedTab && $scope.partitionConfigurations[$scope.selectedTab]) {
        $scope.queryModel.set["tag_dimension.partition_ss"] = [$scope.partitionConfigurations[$scope.selectedTab]];
      }

      if ($scope.queryModel && $rootScope.lastSearchValueInput && $scope.queryModel.set["atex_desk_text"] === undefined){
        $scope.queryModel.set["atex_desk_text"] = $rootScope.lastSearchValueInput;
      }

      if (clearFolder || fromUI) {
        $rootScope.$broadcast('dam:clearAdvancedFields', $scope.selectedTab,  $scope.queryModel.set);
      }
    };

    $scope.$on('dam:resetSearch', function(event) {
      $scope.clearAdvancedFields(true, false);
    });

    $scope.$on('dam:tabSearchOnStartUp', function(event) {
      $scope.submit();
    });

    $scope.$on("dam:initSearch", function (event, extraInfo) {
      setSearchTag(extraInfo);
    });

    $scope.$on("dam:clearFolderInfo", function (event) {
      setSearchTag(undefined);
    });

    var setSearchTag = function (extraInfo) {
      $scope.lastExtraInfo = extraInfo;
      if (DamFoldersService.listingFolder) {
        $scope.searchTag = DamFoldersService.listingFolder.name;
      } else if (extraInfo && extraInfo.type === "webSection") {
        $scope.searchTag = extraInfo.name;
      }
      else {
        $scope.searchTag = undefined;
      }
    };

    $scope.hasQueryEmailAlertPermission = false;

    var pushUsers = function(v, users) {
      if (!v || !v.length || !users || !users.length) {
        return;
      }
      _.each(v, function (u) {
        users.push(u);
      });
    };

    // only when editing an existing query we will show the email query alert box.
    if ($scope.editName && $scope.query && $scope.query.distributionList && !$scope.query.hiddenQuery) {
      $scope.distributionListsContent = [];
      $timeout(function() {
        DamAclPermissionService.hasQueryEmailAlertPermission().then(function (hasPermission) {
          if (hasPermission) {
            return DamDistributionListService.getDistributionLists({type: 'email'});
          } else {
            return {};
          }
        }).then(function (data) {
          if (data && data.groups) {
            _.each(_.map(data.groups, function (g) {
              return {
                name: g,
                type: 'group'
              };
            }), function (i) {
              $scope.distributionListsContent.push(i);
            });
          }
          if (data && data.users) {
            _.each(_.map(data.users, function (u) {
              return {
                name: u,
                type: 'user'
              };
            }), function (i) {
              $scope.distributionListsContent.push(i);
            });
          }
          $scope.hasQueryEmailAlertPermission = $scope.distributionListsContent.length > 0;
        }).then(null, function (error) {
          console.log(error);
        });
      });

      // this is needed since the user widgets expect
      // a function that return a promise.

      $scope.userProviders = function () {
        return $q(function(resolve, reject) {
          resolve($scope.distributionListsContent);
        });
      };
    }

    $scope.cancel = function() {
      if ($scope.cancelCallBack) {
        $scope.cancelCallBack({
        });
      }
    };

    function commit(query) {
      if (query.set) {
        UIConfigurationService.commit(query, $scope.info().name, $scope.info().id, $scope.info().profile, $scope.selectedTab).then(function (query) {
          delete query.set;
          delete query.operators;
          delete query.models;
          delete query.extraValues;
          submit(query);
        });
      } else {
        submit(query);
      }
    }

    function submit(query2Return) {
      $scope.submitCallBack({
        'query' : query2Return
      });
    }

    function addHermesType(query2Return, types, hermesType, extraValues) {
      if (_.contains(_.pluck(types, "id"), "page") && !hermesType) {
        query2Return.set['physicalPage_ss'] = "false";
      } else if (_.contains(_.pluck(extraValues, "id"), "page") && !hermesType) {
        query2Return.set['physicalPage_ss'] = "false";
      } else if (!hermesType) {
        delete query2Return.set['physicalPage_ss'];
      }
    }

    $scope.$watch('$viewContentLoaded',
      function() {
        $timeout(function() {
          UIConfigurationService.getSearchOptions().then(function (options) {
            atex.dam.AngularUtils.highlightInputFields(atex.onecms.ObjectUtils.getByPath(options, 'defaultHighlightInputCss') || "");
          });
        },1000);
      });

    var removeBudgetViewFilter = function () {
      if ($scope.query.budgetView){
        $scope.query.budgetView = false;
        $scope.resetQuery(false,true);
        $scope.clearAdvancedFields(false,true);
      }
    };

    $rootScope.$on("dam:advancedsearchloaded", function() {
      removeBudgetViewFilter();
      $timeout(function () {
        setSearchTag($scope.lastExtraInfo);
      });
    });


    $scope.submit = function() {
      if ($scope.submitCallBack) {
        if ($scope.query.budgetView){
          $scope.query.budgetView = false;
          $scope.setDefaultSorting(true);
        }
        var query2Return = angular.copy($scope.queryModel);
        for (var k in query2Return) {
          if (k.endsWith('_element_types')) {
            delete query2Return[k];
            continue;
          }
        }

        query2Return._type = "atex.dam.standard.Query";

        // Check if we need to remove fullText
        if($scope.physicalPages !== "true") {
        if (!atex.onecms.ObjectUtils.getByPath(query2Return, "set/atex_desk_text")) {
          query2Return.fullText = '';
        }
        }

        if(!query2Return.set) {
          query2Return.set = {};
        }

        var coding = atex.onecms.ObjectUtils.getByPath(query2Return, "set/tag_dimension.markas-iconcoding_ss");
        if (!coding || coding === "0") {
          delete query2Return.set['tag_dimension.markas-iconcoding_ss'];
        }

        var type = atex.onecms.ObjectUtils.getByPath(query2Return, "set/atex_desk_objectType");
        var operator = atex.onecms.ObjectUtils.getByPath(query2Return, "operators/atex_desk_objectType") === true;
        var hermesType = atex.onecms.ObjectUtils.getByPath(query2Return, "set/physicalPage_ss");
        delete query2Return.extraValues;

        if (!type || type.length <= 0) {
          if(operator) {
            query2Return.operators['atex_desk_objectType'] = false;
            addHermesType(query2Return, query2Return.set['atex_desk_objectType'], hermesType);
            commit(query2Return);
          } else {
            UIConfigurationService.configuration($scope.info().name, $scope.info().id, 'atex_desk_objectType', $scope.info().profile, $scope.selectedTab).then(function (configuration) {
              query2Return.set['atex_desk_objectType'] = configuration.fields;
              addHermesType(query2Return, query2Return.set['atex_desk_objectType'], hermesType);
              commit(query2Return);
            });
          }
        } else {
          if (operator) {
            UIConfigurationService.configuration($scope.info().name, $scope.info().id, 'atex_desk_objectType', $scope.info().profile, $scope.selectedTab).then(function (configuration) {
              var types = configuration.fields;
              _.each(type, function (_type) {
                types = _.without(types, _.findWhere(types, {
                  id: _type.id
                }));
              });

              if(!query2Return.extraValues) {
                query2Return.extraValues = [];
              }
              query2Return.extraValues['atex_desk_objectType'] = types;
              addHermesType(query2Return, query2Return.set['atex_desk_objectType'], hermesType, types);
              commit(query2Return);
            });
          } else {
            addHermesType(query2Return, query2Return.set['atex_desk_objectType'], hermesType);
            commit(query2Return);
          }
        }
      }
    };
  } ]);

angular.module('atex.dam').directive('damSearchForm',[ '$q', 'UIConfigurationService', function($q, UIConfigurationService) {
  return {
    restrict: 'E',

    template: '<div ng-include="getContentUrl()"></div>',

    replace: true,

    scope: {
      query: '=',
      editName: '@',
      submitCallBack: '&',
      cancelCallBack: '&',
      template: '@',
      physicalPages: '@',
      queryId: '@',
      selectedTab: '@'
    },

    controller: 'DamSearchFormController',

    link: function (scope) {
      function isEmpty(query) {

      }

      function notValid(query) {
        var error = false;
        if (query && query.fields && query.fields.length > 0) {
          var _field = _.find(query.fields, function (field) {
            return field.key === "physicalPage_ss";
          });

          if (_field && _field.values && _field.values.length > 0) {
            var physicalPageQuery = _field.values[0] === "true";
            if (physicalPageQuery) {
              var physicalPageTemplate = scope.physicalPages === "true";
              error = !(physicalPageQuery && physicalPageTemplate);
            }
          }
        }

        return error;
      }

      scope.getContentUrl = function () {
        return scope.template || 'js/dam/widgets/dam-search-form/dam-search-form.html';
      };

      var checkSorting = function () {
        if (scope.queryModel.sortValue === undefined || scope.queryModel.sortOrderValue === undefined) {
          scope.setDefaultSorting(false);
        }
      };

      scope.queryModel = angular.copy(scope.query);
      checkSorting();

      scope.$watch(function () {
        return scope.query;
      }, function (newValue) {
        if(notValid(newValue)) {
          return;
        }

        if(_.isEmpty(newValue) && scope.physicalPages === "true") {
          scope.queryModel = angular.copy(scope._defaultPhysQuery);
        } else {
          scope.queryModel = angular.copy(newValue);
        }

        checkSorting();

        if (!scope.queryModel.hiddenQuery) {
        if (scope.queryModel.fullText || scope.queryModel.fields) {
          scope.queryModel.set = {};
          scope.queryModel.operators = {};
          scope.queryModel.extraValues = {};
        }
        if (scope.queryModel.fullText) {
          // Preserve the fulltext search
          scope.queryModel.set['atex_desk_text'] = scope.queryModel.fullText;
        }

        if (scope.queryModel.fields) {
          var fields = atex.onecms.ObjectUtils.getByPath(scope.queryModel, "fields") || [];
          fields.forEach(function(field){
            if (field.type === 'DATE') {
              if (field.disablePatchDate === true){
                atex.dam.ViewUtils.patchDateIntervalFullRange(field.values);
              }else{
                atex.dam.ViewUtils.patchDateInterval(field.values);
              }
            }
          });

            UIConfigurationService.configuration(scope.info().name, scope.info().id, 'atex_desk_objectType', scope.info().profile, scope.selectedTab).then(function (configuration) {
            var type = _.find(fields, function (field) {
              return field.key === "atex_desk_objectType";
            });

            var _type = atex.onecms.ObjectUtils.getByPath(type, "values") || [];
            var _conf = atex.onecms.ObjectUtils.getByPath(configuration, "fields") || [];

            if (_type.length >= _conf.length) {
              scope.queryModel.fields = _.without(scope.queryModel.fields, _.findWhere(scope.queryModel.fields, {
                key: 'atex_desk_objectType'
              }));
            }

            var promises = scope.queryModel.fields.map(function (field) {
                return UIConfigurationService.draw(field, scope.info().name, scope.info().id, scope.info().profile, scope.selectedTab).then(function (values) {
                scope.queryModel.set[field.key] = values;
                scope.queryModel.operators[field.key] = field.operator;
                scope.queryModel.extraValues[field.key] = field.extraValues;
              });
            });

            $q.all(promises).then(function () {
              delete scope.queryModel.fields;
            });
          });
        }
        } else {
          delete scope.queryModel.hiddenQuery;
        }
      }, true);
    }
  };
}]);
